var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.238 3.04401C5.652 2.18201 3.75 3.32001 3.75 5.03301V18.967C3.75 20.681 5.652 21.818 7.238 20.956L20.05 13.989C21.65 13.119 21.65 10.881 20.05 10.012L7.238 3.04401ZM2.25 5.03301C2.25 2.12801 5.417 0.34601 7.955 1.72701L20.767 8.69401C23.411 10.132 23.411 13.868 20.767 15.306L7.955 22.273C5.417 23.653 2.25 21.873 2.25 18.967V5.03301Z",
    fill: "currentColor"
  })));
};
export default SvgPlay;